import {
    FETCH_BRANDS,
    SAVE_BRAND,
    FETCH_FULL_BRAND,
    UPDATE_BRAND,
    UPDATE_BRAND_THEME,
    UPLOAD_BRAND_ASSET,
    REMOVE_BRAND_ASSET,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_BRANDS:
            return action.payload;
        case SAVE_BRAND:
            return state.concat(action.payload);
        case UPDATE_BRAND:
        case UPDATE_BRAND_THEME:
            return state.map(brand => brand.key === action.payload.key ? { ...brand, ...action.payload } : brand);
        case FETCH_FULL_BRAND:
            if (state.find(brand => brand.key === action.payload.key)) {
                return state.map(brand => brand.key === action.payload.key ? { ...brand, ...action.payload } : brand);
            } else {
                return state.concat(action.payload);
            }
        case UPLOAD_BRAND_ASSET:
        case REMOVE_BRAND_ASSET:
            return state.map(brand => brand.key === action.meta.brandKey ? { ...brand, assets: updateAssets(brand.assets, action.meta.keyPath, action.payload) } : brand);
        default:
            return state;
    }
};

function updateAssets(assets, path, asset) {
    assets[path].assets = assets[path].assets.filter(({ key }) => key !== asset.key);

    if (asset.url) {
        asset.url += '?d=' + new Date().getTime();
        assets[path].assets.push(asset);
    }

    return { ...assets };
}